import { render, staticRenderFns } from "./LayoutDrawerCustomiseCoverFormBase.vue?vue&type=template&id=7fd77ad4&scoped=true&"
import script from "./LayoutDrawerCustomiseCoverFormBase.vue?vue&type=script&lang=js&"
export * from "./LayoutDrawerCustomiseCoverFormBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd77ad4",
  null
  
)

export default component.exports